import { forwardRef } from 'react';
import { Inset as RadixInset } from '@radix-ui/themes';
import type { RadixInsetProps } from '@/types/radix-ui';

/**
 * Inset component - wrapper around Radix UI Inset
 * Provides consistent internal padding for content areas
 */
export type InsetProps = RadixInsetProps;

const Inset = forwardRef<HTMLDivElement, InsetProps>((props, ref) => {
  return <RadixInset ref={ref} {...props} />;
});

Inset.displayName = 'Inset';

export { Inset };
